import {
  Box,
  Card,
  Button,
  TextField,
  Typography,
  Breadcrumbs,
  Stack,
} from "@mui/material";
import Image from "../PatientsDasboard/Image";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import useDetails from "src/hooks/useDetails";
import { useTheme } from "@mui/material/styles";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import * as React from "react";
import { useState } from "react";
import axios from "axios";
import CustomSnackbar from "../../utils/CustomSnackbar";
import useSettings from "../../hooks/useSettings";
import { useNavigate } from "react-router-dom";

const ReportIssue = () => {
  const userDetails = useDetails();
  const navigate = useNavigate();
  let u_id = userDetails?.user_id;
  let u_role = userDetails?.rolesname[0];

  const [openSnack, setOpenSnack] = useState({
    open: false,
    severity: null,
    message: null,
  });
  const { themeStretch } = useSettings();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();

  const [issue_upload, setUpload] = useState([]);
  const [previews, setPreviews] = useState([]); // To store image previews

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files); // Convert FileList to array
    setUpload(files); // Set the files to the state for submission

    const filePreviews = files.map((file) => URL.createObjectURL(file)); // Generate preview URLs
    setPreviews(filePreviews);
  };

  const handleFormSubmit = (values) => {
    const formData = new FormData();
    formData.append("issue_description", values.issue_description);
    formData.append("u_id", u_id);
    formData.append("u_role", u_role);

    issue_upload.forEach((file) => {
      formData.append("issue_upload", file);
    });
    console.log(issue_upload);
    console.log(formData);
    axios
      .post(
        `${process.env.REACT_APP_KAIZEN_API}/api/dev3/reportinsert`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        console.log("response", response);
        {
          setOpenSnack({
            open: true,
            severity: "success",
            message: "Report Submitted Successfully",
            position: ["bottom", "center"],
          });
          setTimeout(() => {
            navigate("/");
          }, 2000);
        }
      })
      .catch((error) => {
        console.error("Error reporting issue:", error);
        setOpenSnack({
          open: true,
          severity: "error",
          message: "Something went wrong while reporting the issue.",
        });
      });
  };

  return (
    <>
      {CustomSnackbar(openSnack.open, openSnack.severity, openSnack.message)}
      <Helmet>
        <title>Report an Issue | Kaizen Digital</title>
      </Helmet>
      <Typography variant="h3" sx={{ mb: 0 }} color="primary">
        Report an Issue
      </Typography>

      <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" to="/">
          Dashboard
        </Link>
        <Link underline="hover" color="inherit" to="">
          Report{" "}
        </Link>
        <Typography color="text.primary">Report an Issue</Typography>
      </Breadcrumbs>
      <br />

      <Card>
        <Box m="20px">
          <Formik
            initialValues={initialValues}
            validationSchema={checkoutSchema}
            onSubmit={handleFormSubmit}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(1, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 6",
                    },
                  }}
                >
                  <Typography variant="h6">
                    Report an Issue related to Kaizen Zenith Platform{" "}
                  </Typography>
                  <Typography variant="body1">
                    We apologize for the inconvenience you faced when using our
                    platform. Please follow the instructions below:
                    <ol style={{ marginLeft: "30px" }}>
                      <li>Tell us when you started facing this issue.</li>
                      <li>
                        Write a detailed description for quicker resolution.
                      </li>
                      <li>Upload a screenshot of the issue you encountered.</li>
                    </ol>
                  </Typography>
                </Box>

                <TextField
                  name="issue_description"
                  value={values.issue_description}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  multiline
                  rows={7}
                  fullWidth
                  placeholder="Describe the issue..."
                  error={
                    touched.issue_description &&
                    Boolean(errors.issue_description)
                  }
                  helperText={
                    touched.issue_description && errors.issue_description
                  }
                />
                <Typography>
                  <br />
                </Typography>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Button
                    variant="contained"
                    component="label"
                    sx={{ color: "white" }}
                  >
                    Image Upload
                    <input
                      hidden
                      accept="image/*"
                      multiple
                      type="file"
                      onChange={handleFileChange}
                    />
                  </Button>
                </Stack>
                <Box display="flex" flexWrap="wrap" gap="10px" mt="20px">
                  {previews.map((preview, index) => (
                    <img
                      key={index}
                      src={preview}
                      alt={`Preview ${index + 1}`}
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "5px",
                      }}
                    />
                  ))}
                </Box>
                <Box display="flex" justifyContent="end" mt="20px">
                  <Button type="submit" variant="contained">
                    {/* <Button type="submit" onClick={handleFormSubmit} variant="contained"> */}
                    Report Now
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Box>
      </Card>
    </>
  );
};

const checkoutSchema = yup.object().shape({
  issue_description: yup.string().required("Please provide a description."),
});

const initialValues = {
  issue_description: "",
};

export default ReportIssue;
